import { Rnd } from 'react-rnd';
import { OVERLAY_TYPES, OVERLAY_TYPE_ICONS } from './overlayDefaults';
import { layerImageStyle, needsChannel } from './editorModel';
import styles from './LayoutEditor.module.css';

function clamp(val, min, max) {
  return Math.max(min, Math.min(max, val));
}

export default function OverlayItem({ overlay, layer, canvasSize, isSelected, onSelect, onPositionChange }) {
  const { width: cw, height: ch } = canvasSize;
  const { position } = overlay;

  const pxX = position.x * cw;
  const pxY = position.y * ch;
  const pxW = position.width * cw;
  const pxH = position.height * ch;

  const typeLabel = OVERLAY_TYPES.find(t => t.value === overlay.type)?.label ?? overlay.type;

  const handleDragStop = (_e, d) => {
    const newX = clamp(d.x / cw, 0, 1 - position.width);
    const newY = clamp(d.y / ch, 0, 1 - position.height);
    onPositionChange(overlay._id, { ...position, x: newX, y: newY });
  };

  const handleResizeStop = (_e, _dir, ref, _delta, pos) => {
    const newW = clamp(ref.offsetWidth / cw, 0.04, 1);
    const newH = clamp(ref.offsetHeight / ch, 0.03, 1);
    const newX = clamp(pos.x / cw, 0, 1 - newW);
    const newY = clamp(pos.y / ch, 0, 1 - newH);
    onPositionChange(overlay._id, { x: newX, y: newY, width: newW, height: newH });
  };

  return (
    <Rnd
      position={{ x: pxX, y: pxY }}
      size={{ width: pxW, height: pxH }}
      bounds="parent"
      minWidth={cw * 0.04}
      minHeight={ch * 0.03}
      lockAspectRatio={overlay.type === 'track_map' || overlay.type === 'gauge'}
      onDragStart={() => onSelect(overlay._id)}
      onResizeStart={() => onSelect(overlay._id)}
      onDragStop={handleDragStop}
      onResizeStop={handleResizeStop}
      onClick={e => { e.stopPropagation(); onSelect(overlay._id); }}
      style={{ zIndex: 5 }}
      enableResizing={isSelected ? {
        top: true, right: true, bottom: true, left: true,
        topRight: true, bottomRight: true, bottomLeft: true, topLeft: true,
      } : false}
      resizeHandleClasses={{
        topLeft: styles.resizeHandle, topRight: styles.resizeHandle,
        bottomLeft: styles.resizeHandle, bottomRight: styles.resizeHandle,
      }}
    >
      <div
        className={`${styles.overlayItem} ${isSelected ? styles.overlayItemSelected : ''}`}
        title={`${overlay.label || overlay.channel || typeLabel} — drag to move`}
      >
        {layer && !needsChannel(overlay) ? (
          layer.image && <img src={layer.image} alt={overlay.label || typeLabel} draggable={false}
            className={styles.layerImage} style={layerImageStyle(layer)} />
        ) : (
          <div className={styles.overlayPlaceholder}>
            <span className={styles.overlayIcon}>{OVERLAY_TYPE_ICONS[overlay.type]}</span>
            <span className={styles.overlayTypeLabel}>{typeLabel}</span>
            <span className={styles.overlayUserLabel}>{needsChannel(overlay) ? 'Choose a channel' : 'Loading preview…'}</span>
          </div>
        )}
      </div>
    </Rnd>
  );
}
